document.addEventListener('DOMContentLoaded', () => {
    const jspasstoggle = document.querySelectorAll('.js-pass-toggle');
    jspasstoggle.forEach((item, index) => {
        item.addEventListener('click',(e)=>{
            const pass = item.nextElementSibling;
            const type = pass.getAttribute('type');
            const icon = item.querySelector('.icon');
            if(type === 'password'){
                pass.setAttribute('type','text');
                icon.classList.add('icon--pass-show');
            }
            if(type === 'text'){
                pass.setAttribute('type','password');
                icon.classList.remove('icon--pass-show');
            }
        });
    });
});
